import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

// Featured Industries accordion — inspired by the navy-serif "Featured Industries"
// reference. Lightweight teaser to use on Home; deeper grid lives on /industries.
const FEATURED = [
    {
        id: "banking",
        title: "Banking & Financial Services",
        body: "Navigating compliance and operational risk for financial institutions. Our team helps you manage AML reviews, address cyber-risk documentation and strengthen reconciliations end-to-end.",
    },
    {
        id: "saas",
        title: "IT & SaaS Companies",
        body: "Customer onboarding, technical documentation, subscription billing and CRM operations — handled by a team that already speaks your stack.",
    },
    {
        id: "ecommerce",
        title: "E-commerce & DTC",
        body: "Order processing, multi-marketplace reconciliations, inventory and customer-support tickets across time zones — a fully-staffed back office that scales with your peak weeks.",
    },
    {
        id: "real-estate",
        title: "Real Estate & Property",
        body: "Lease administration, tenant communication, financial reporting and document management for portfolios of any size, with audit-grade trails.",
    },
    {
        id: "healthcare",
        title: "Healthcare Support",
        body: "Non-clinical back-office support — patient scheduling, billing assistance, claims documentation and regulatory compliance — built for European and US providers.",
    },
    {
        id: "consulting",
        title: "Consulting & Advisory",
        body: "Proposal preparation, research dossiers, CRM hygiene and client reporting — so your partners and senior consultants can focus on selling and delivering work.",
    },
];

export default function IndustriesAccordion() {
    return (
        <section className="section container-page" data-testid="industries-accordion">
            <div className="grid lg:grid-cols-12 gap-10 mb-12 items-end">
                <div className="lg:col-span-7">
                    <p className="overline mb-3">Sectors we know</p>
                    <h2 className="display text-4xl md:text-5xl lg:text-6xl text-brand-ink leading-[1.05]">
                        Featured industries.
                    </h2>
                </div>
                <div className="lg:col-span-5">
                    <p className="text-brand-ink/75 leading-relaxed">
                        A snapshot of where we work most often. Tap any sector for the operational
                        patterns we see, and how Vittaniti plugs in.
                    </p>
                    <Link to="/industries" className="btn-ghost mt-5" data-testid="industries-accordion-all">
                        See all industries <ArrowUpRight size={16} />
                    </Link>
                </div>
            </div>

            <div className="rounded-2xl border border-brand-border bg-white overflow-hidden"
                 style={{ boxShadow: "0 14px 30px -22px rgba(20,34,57,0.18)" }}>
                <Accordion type="single" collapsible defaultValue="banking" className="w-full">
                    {FEATURED.map((item, i) => (
                        <AccordionItem
                            key={item.id}
                            value={item.id}
                            data-testid={`featured-industry-${item.id}`}
                            className={`border-brand-border ${i === FEATURED.length - 1 ? "border-b-0" : ""}`}
                        >
                            <AccordionTrigger className="px-6 md:px-8 py-5 hover:no-underline group">
                                <span className="font-serif text-2xl md:text-3xl text-brand-ink leading-tight text-left">
                                    {item.title}
                                </span>
                            </AccordionTrigger>
                            <AccordionContent className="px-6 md:px-8 pb-6">
                                <p className="text-brand-ink/75 leading-relaxed max-w-3xl">
                                    {item.body}
                                </p>
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
